import { z } from "zod";
import { defineEvent } from "./_define";
import { baseEnvelopeSchema } from "./_envelope";

/**
 * Fires once per wizard step, when that step is actually on screen — see
 * `useScreenViewed`, which every home/intake wizard funnels through. The value
 * is the step id (e.g. `"paywall"`, `"questionnaire"`); `route` / `surface` /
 * `entrypoint_id` come free from the `useStatsigClient` wrapper, so the value
 * alone is enough to slice a funnel.
 *
 * View-timed, not mount-timed: it rides the same visibility signal as
 * `content_visible` (PE-1534). Owlet warm-loads Felt pages at app launch, so a
 * step can mount before — or without — the user seeing it; `useScreenViewed`
 * gates on the page being visible (non-zero viewport + `visibilityState:
 * "visible"`) and defers until then, so a preloaded step doesn't count a view
 * nobody saw. `screen_viewed` is the per-step signal within a wizard;
 * `content_visible` is the per-route one — same gate, different granularity.
 *
 * Route-level: filter on `value` (the step) plus `route` / `surface`.
 */
export const screenViewed = defineEvent({
  eventName: "screen_viewed",
  eventVersion: 1,
  valueSchema: z.string().min(1),
  metadataSchema: baseEnvelopeSchema.passthrough(),
});
